import {
  API_JSON_CONTENT_TYPE,
  createEndpointFetch,
} from '@web-config-app/api';
import { useQuery } from '@tanstack/react-query';
import { EnvironmentKey, ConfigAppTenantResponse } from '@web-config-app/core';
import { useEnvironmentFetch } from '../use-environment-fetch/use-environment-fetch';

interface UseFetchTenantConfigProps {
  environmentKey: EnvironmentKey;
  tenantId: string;
  isAuthenticated?: boolean;
}

export const useFetchTenantConfig = ({
  environmentKey,
  isAuthenticated,
}: UseFetchTenantConfigProps) => {
  const headers = {
    'Content-Type': API_JSON_CONTENT_TYPE,
  };

  const path = `/v1/config-app-tenant`;

  const environmentFetch = useEnvironmentFetch(environmentKey);

  const queryFn = async () => {
    const endpointConfig = {
      path,
      method: 'GET',
    } as const;

    const tenantFetch = createEndpointFetch<ConfigAppTenantResponse>(
      endpointConfig,
      environmentFetch,
    );

    return tenantFetch({
      headers,
    });
  };

  const isEnabled = isAuthenticated;

  const { data: queryResultData, ...queryResult } = useQuery({
    queryKey: ['tenantConfig', path, environmentKey],
    queryFn,
    staleTime: Infinity,
    enabled: isEnabled,
  });

  return {
    ...queryResult,
    data: queryResultData?.data,
  };
};
